import React from 'react';

export default function HomeHeader() {
  return (
    <header className="mb-4">
      <h1 className="text-4xl font-serif mb-2" style={{ color: '#111111' }}>
        Your <span style={{ color: '#7C3AED' }}>Home</span>
      </h1>
      <p className="text-base" style={{ color: '#555555' }}>
        A living feed of your curiosity, patterns, and insights.
      </p>
    </header>
  );
}

